import useSWR from 'swr';

import { fetcher, endpoints } from 'src/lib/axios';

export function useJobPostingDetails(jobId: string | null | undefined) {
  const key = jobId ? endpoints.jobs.details(jobId) : null;
  return useSWR(key, fetcher, { dedupingInterval: 5000 });
}
